import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="main-footer text-right ">
        Copyright &copy; 2025{" "}
        <a
          href="https://www.la-z-boy.com/"
          className="text-color"
          target="_blank"
        >
          {" "}
          LAZBOY
        </a>
        .All rights reserved.
      </footer>
    );
  }
}
export default Footer;
